import React from "react";

import { Box, Chip, Stack, TextField, Typography } from "@mui/material"
import {
  EyewitnessProps,
} from "../../interface/posts";
import { ImageUpload } from "../image-upload";

const ReportThree = ({
  next,
  prev,
  report_data,
  setReport_data,
}: EyewitnessProps) => {
  const handle_images = (images: { data_url: string; file: File }[]) => {
    setReport_data((prev) => ({ ...prev, media: images }));
  };
  
  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          height: "4px",
          background: "url(/assets/icons/posts/line-03.png)",
        }}
      />
      <Stack sx={{ mt: 3, px: 2 }}>
        <Typography
          color="black"
          variant="body2"
          sx={{
            fontSize: 15,
            fontWeight: 500,
          }}
        >
          Add media file
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "#7991A4",
          }}
        >
          Upload images, videos, or documents to support your report or
          petition. Ensure the files are clear and relevant to help strengthen
          your case.
        </Typography>
      </Stack>
      <Stack sx={{ my: 2 }}>
        <ImageUpload
          multiple={true}
          showText={false}
          styles={{ backgroundColor: "fafafa" }}
          onSelect={handle_images}
        />
      </Stack>
      <Stack sx={{ px: 2 }} direction={"row"} justifyContent={"flex-end"}>
        <Chip
          label="Back"
          onClick={() => prev()}
          sx={{
            backgroundColor: "#92A5B5",
            color: "#fafafa",
            mx: 1,
          }}
        />
        <Chip
          label="Continue"
          onClick={() => next()}
          color="primary"
          sx={{
            color: "#fafafa",
            px: 1,
          }}
        />
      </Stack>
    </Box>
  );
};

export default ReportThree;
